module.exports = __webpack_public_path__ + "img/xp-tb-deliver-the-right-game.efe3ea7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb-deliver-the-right-game.png
// module id = g68q
// module chunks = 38 43